import { useState } from "react";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { ModalShell } from "./ModalShell";

export function ImportModal({ onCancel, onImport }) {
  const [file, setFile] = useState(null);
  const [summary, setSummary] = useState(null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const runImport = async (dryRun) => {
    if (!file) {
      setError("Choose a CSV file first.");
      return;
    }

    setBusy(true);
    setError("");
    try {
      const result = await onImport(file, dryRun);
      setSummary(result);
      if (!dryRun) {
        onCancel();
      }
    } catch (requestError) {
      setError(requestError.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <ModalShell icon={<FileUploadIcon />} title="Import CSV" onClose={onCancel}>
      <div className="modal-field">
        <label htmlFor="csv-file">CSV file</label>
        <input
          id="csv-file"
          type="file"
          accept=".csv,text/csv"
          onChange={(event) => setFile(event.target.files?.[0] || null)}
        />
      </div>
      <div className="helper-text">
        Required columns: item_name, row_number, bay_number, is_dropped, note,
        partial_count.
      </div>
      {summary && (
        <div className="import-summary">
          <strong>{summary.dryRun ? "Dry run" : "Import"} summary</strong>
          <div>Rows: {summary.rows}</div>
          <div>New items: {summary.insertedItems}</div>
          <div>New locations: {summary.insertedLocations}</div>
          <div>Updated locations: {summary.updatedLocations}</div>
        </div>
      )}
      {error && <div className="import-errors">{error}</div>}
      <div className="modal-actions">
        <button type="button" className="touch-button" onClick={onCancel}>
          Cancel
        </button>
        <button
          type="button"
          className="touch-button"
          onClick={() => runImport(true)}
          disabled={busy || !file}
        >
          Dry Run
        </button>
        <button
          type="button"
          className="touch-button"
          onClick={() => runImport(false)}
          disabled={busy || !file}
        >
          Import
        </button>
      </div>
    </ModalShell>
  );
}
